<template>
  <div class="col-12">
    <div class="elfsight-app-c349f1d8-7c7e-4b27-93c1-be19944e141b"></div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped src="../../assets/css/home.css"></style>
